<template>
	<div class="information_home" :style="tabActiveOld === 3?'padding:0':''">
		<div class="information_home-tab">
			<van-tabs v-model="tabActiveOld" color="#1F2329">
				<van-tab
					:name="1"
					:badge="getInformationState.patientEducationStatus?'NEW':''"
					title="专属患教"
				></van-tab>
				<van-tab :name="2" :badge="getInformationState.popularStatus?'NEW':''" title="科普资讯"></van-tab>
				<van-tab :name="3" title="康复视频"></van-tab>
			</van-tabs>
		</div>
		<kangfu v-if="tabActiveOld === 3" />
		<template v-else>
			<van-list
				v-if="list.length"
				v-model="loading"
				:finished="!loading && list.length >= total"
				finished-text="没有更多了"
				@load="load"
			>
				<information-list-item
					v-for="item in list"
					:key="item.id"
					:title="item.titleName"
					:issue-date="item.gmtCreate.split(' ')[0]"
					:cover="item.coverUrl"
					:type="item.category"
					:videoUrl="item.videoUrl"
					:showTag="item.readStatus===0"
					@click="$router.push(`/information/detail/${ item.id }/${item.isPatientEducation}`)"
				/>
			</van-list>
			<van-empty v-else description="暂无科普资讯内容">
				<template #image>
					<img class="empty_img" src="@/assets/img/empty_2.png" alt="" />
				</template>
			</van-empty>
		</template>
	</div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import kangfu from './kangfu.vue'
export default {
    components: { kangfu },
    name: 'informationHome',
    data: () => ({
        loading: false,
        page: 1,
        limit: 10,
        list: [],
        total: 0,
        // tabActive:1,
        unreadNum: 0,
    }),
    watch: {
        tabActive: function (val) {
            if (val !== 3) {
                this.init()
            }
        }
    },
    computed: {
        ...mapGetters('information', ['tabActive', 'getInformationState']),
        tabActiveOld: {
            get () {
                return this.tabActive
            },
            set (val) {
                this.SET_INFORMATION_TABACTIVE(val)
            }
        }
    },
    created () {
        this.init()
    },
    methods: {
        ...mapMutations('information', ['SET_INFORMATION_TABACTIVE']),
        init () {
            this.loading = false
            this.list = []
            this.total = 0
            this.page = 1
            this.load()
        },
        load () {
            this.loading = true
            let params = {
                patientId: this.$store.getters['account/getPatientId'],
                status: 1,
                page: this.page,
                limit: this.limit,
                listType: this.tabActiveOld
            }
            this.$api.information.page(params).then(res => {
                this.loading = false
                if (!res.code) {
                    this.total = res.data.total
                    this.unreadNum = res.data.unreadNum
                    this.getStatus()
                    this.list = [...this.list, ...res.data.list]
                    this.page++
                }
            }).catch(() => this.loading = false)
        },
        getStatus () {
            this.$store.dispatch('information/apiGetInformationStatus', {
                params: this.$store.getters['account/getPatientId']
            })
        },
        kangfu () {

        }
    }
}
</script>

<style scoped lang="less">
.information_home {
	padding: 0 32px;
}
</style>

<style lang="less">
.information_home {
	&-tab {
		margin: 0 auto;
	}
	.van-empty {
		padding-top: 300px;
		.van-empty__image {
			height: initial;
		}
		.van-empty__description {
			font-family: PingFangSC-Regular;
			font-size: 26px;
			font-weight: normal;
			line-height: 31px;
			color: #8f959e;
		}
	}
}
</style>
